export default [
  {
    path: '/classcard/honour/list',
    name: 'PageHonourList',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/honour/PageHonourList'
      ),
    meta: { modular: 41, title: '学生荣誉', info: '学生荣誉——首页' }
  },
  {
    path: '/classcard/honour/publish',
    name: 'PageHonourPublish',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/honour/PageHonourPublish'
      ),
    meta: { modular: 41, title: '发布荣誉', info: '学生荣誉——发布荣誉' }
  },
  {
    path: '/classcard/honour/detail',
    name: 'PageHonourDetail',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/honour/PageHonourDetail'
      ),
    meta: { modular: 41, title: '学生荣誉', info: '学生荣誉——详情' }
  },
  {
    path: '/classcard/honour/padList',
    name: 'PageHonourPadList',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/honour/PageHonourPadList'
      ),
    meta: { modular: 41, title: '学生荣誉', info: '学生荣誉——设备列表' }
  }
]
